import Vue from 'vue'

function focusInput(el, binding) {
  // Focus the element
  if (!('value' in binding) || binding.value) {
    el.focus({
      preventScroll: binding.arg === 'preventScroll'
    })
    if (el.selectionEnd) {
      el.selectionEnd = 0
    }
    el.scrollTop = 0
    el.scrollLeft = 0
  }
}

Vue.directive('autofocus', {
  inserted(el, binding) {
    setTimeout(() => focusInput(el, binding), 0)
  },
  update(el, binding) {
    !binding.oldValue && binding.value && focusInput(el, binding)
  }
})

function bindClickOutside(el, binding, vnode) {
  el.clickOutsideEvent = function(event) {
    // here I check that click was outside the el and his children
    if (!(el == event.target || el.contains(event.target))) {
      // and if it did, call method provided in attribute value
      binding.value.call(vnode.context, event)
    }
  }
  document.body.addEventListener('click', el.clickOutsideEvent)
}

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    if (binding.value) {
      bindClickOutside(el, binding, vnode)
    }
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
  update: function(el, binding, vnode) {
    if (!binding.oldValue && binding.value) {
      bindClickOutside(el, binding, vnode)
    } else if (binding.oldValue && !binding.value) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  }
})

Vue.directive('autoselect', {
  inserted: function(el, binding) {
    binding.value !== false && el.select()
  }
})

// The presence of this directive ensures that screen recordings will not capture the contents of the element.
// At the moment, we add masking attributes for Matomo and Posthog recordings
Vue.directive('no-capture', {
  bind: el => {
    el.classList.add('ph-no-capture')
    el.dataset.matomoMask = ''
  }
})
